import styled from 'styled-components'

import { helpers } from 'styles'

export const Row = styled.div`
	align-items: center;
	display: flex;

	padding: ${helpers.spacing.small} 0;
	gap: ${helpers.spacing.medium};
`
